import axios from "axios";
import i18next from 'i18next';

const transport = axios.create({
    baseURL: 'https://api.zaheralhomsi-group.com/api/website'
    // baseURL: 'hxttp://127.0.0.1:8000/api/website'
});

transport.interceptors.request.use((config) => {
    const lang = i18next.language || 'ar';
    config.headers['Accept-Language'] = lang;
    return config;
}, (error) => {
    return Promise.reject(error);
});

i18next.on('languageChanged', (lng) => {
    transport.defaults.headers['Accept-Language'] = lng;
});

export default transport;
